import { Button, Select, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import { EditableCell, EditableRow } from './EditableRow';

const { Option } = Select;

export default function EdiTable({ datasource, setDatasource }) {
  const [dataSourceLocal, setDataSourceLocal] = useState(
    datasource === null || datasource === undefined ? [] : datasource
  );
  const [count, setCount] = useState(
    datasource === null || datasource === undefined ? 0 : datasource?.length
  );

  const handleDelete = (key) => {
    let dataSource2 = [...dataSourceLocal];
    dataSource2 = dataSourceLocal.filter((item) => item.key !== key);
    setDataSourceLocal(dataSource2);
    setCount(count - 1);
    setDatasource(dataSource2);
  };

  const handleAdd = () => {
    const countNew = count + 1;
    const newData = {
      pieza: '',
      danho: 'Roto',
      key: countNew
    };
    const dataSourceNew = [...dataSourceLocal, newData];
    setDataSourceLocal(dataSourceNew);
    setCount(countNew);
  };

  const handleSave = (row) => {
    const newData = [...dataSourceLocal];
    const index = newData.findIndex((item) => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, { ...item, ...row });
    setDataSourceLocal(newData);
    setDatasource(newData);
  };

  function handleChange(value, record) {
    try {
      // eslint-disable-next-line no-param-reassign
      record.danho = value;
    } catch (error) {
      // error
    }
  }

  const columnsData = [
    {
      title: 'Pieza Dañada',
      dataIndex: 'pieza',
      key: 'pieza',
      width: '30%',
      editable: true
    },
    {
      title: 'Tipo de Daño',
      dataIndex: 'danho',
      key: 'danho',
      render: (_, record) => {
        return (
          <Select
            defaultValue="Roto"
            style={{ width: 120 }}
            onChange={(value) => {
              handleChange(value, record);
            }}
          >
            <Option value="Roto">Roto</Option>
            <Option value="Abolladura">Abolladura</Option>
            <Option value="Raspón">Raspón</Option>
            <Option value="Faltante">Faltante</Option>
            <Option value="otro">Otro tipo de Daño</Option>
          </Select>
        );
      }
    },
    {
      title: 'Acciones',
      dataIndex: 'operation',
      render: (_, record) =>
        dataSourceLocal.length >= 1 ? (
          <Button danger onClick={() => handleDelete(record.key)}>
            Eliminar
          </Button>
        ) : null
    }
  ];

  const getComponentes = () => {
    const components = {
      body: {
        row: EditableRow,
        cell: EditableCell
      }
    };
    return components;
  };

  const getColumns = () => {
    const columns = columnsData.map((col) => {
      if (!col.editable) {
        return col;
      }

      return {
        ...col,
        onCell: (record) => ({
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave
        })
      };
    });
    return columns;
  };

  useEffect(() => {
    setDataSourceLocal(datasource || []);
  }, [datasource]);

  return (
    <div>
      <Button
        onClick={handleAdd}
        type="primary"
        style={{
          marginBottom: 16
        }}
      >
        Agregar comentario
      </Button>
      <Table
        components={getComponentes()}
        rowClassName={() => 'editable-row'}
        bordered
        fixed
        scroll={false}
        dataSource={dataSourceLocal}
        columns={getColumns()}
      />
    </div>
  );
}
